
import { defineComponent } from "vue";

export default defineComponent({
  name: "error-404",
  components: {},
  setup(){

    function goHome()
    {

    }
    return{
      goHome
    }
  }
});
